import { associatePerformanceService } from 'config/api';
import { formatDateYYYYMMDD } from 'utils';
import actionTypes from './actionTypes';

export const setPerformanceFilters = (filter) => ({
  type: actionTypes.PERF_SET_PERFORMANCE_FILTERS,
  payload: filter,
});

export const clearPerformanceFilters = () => ({
  type: actionTypes.PERF_CLEAR_PERFORMANCE_FILTERS,
});

export const setPerformanceDateFilter = (payload) => ({
  type: actionTypes.PERF_SET_PERFORMANCE_DATE_FILTER,
  payload,
});

export const clearPerformanceDateFilter = () => ({
  type: actionTypes.PERF_CLEAR_PERFORMANCE_DATE_FILTER,
});

export const getPerformanceFilterOptions = ({ startDate, endDate }, associatePin, filter) => async (dispatch) => {
  const params = {
    filter,
    dateFrom: formatDateYYYYMMDD(startDate),
    dateTo: formatDateYYYYMMDD(endDate),
  };

  dispatch({
    type: actionTypes.PERF_FILTER_OPTIONS_LOADING,
  });
  try {
    const res = await associatePerformanceService.post(`v2/data/${associatePin}/filter-options`, params);

    dispatch({
      type: actionTypes.PERF_FILTER_OPTIONS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.PERF_FILTER_OPTIONS_ERROR,
      payload: error,
    });
  }
};
